(function () {
  function initCard(card) {
    const root = card.closest('[data-ghl-root]');
    if (!root) return;

    const toggle = card.querySelector('[data-ghl-toggle]');
    const close = card.querySelector('[data-ghl-close]');

    function closeAll() {
      root.querySelectorAll('[data-ghl-card][data-open="true"]').forEach((el) => {
        el.setAttribute('data-open', 'false');
        const t = el.querySelector('[data-ghl-toggle]');
        if (t) t.setAttribute('aria-expanded', 'false');
      });
    }

    if (toggle) {
      toggle.addEventListener('click', () => {
        const isOpen = card.getAttribute('data-open') === 'true';
        closeAll();
        card.setAttribute('data-open', isOpen ? 'false' : 'true');
        toggle.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      });
    }

    if (close) {
      close.addEventListener('click', () => {
        card.setAttribute('data-open', 'false');
        if (toggle) toggle.setAttribute('aria-expanded', 'false');
      });
    }

    // Close on Escape when focus is inside this card
    card.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        card.setAttribute('data-open', 'false');
        if (toggle) toggle.setAttribute('aria-expanded', 'false');
      }
    });
  }

  function initSection(root) {
    if (!root || root.__ghl_inited) return;
    root.__ghl_inited = true;
    root.querySelectorAll('[data-ghl-card]').forEach(initCard);
  }

  function destroySection(root) {
    // If you ever add listeners outside initCard’s local ones, clean them here.
    if (root) root.__ghl_inited = false;
  }

  // Initial mount (all instances on page)
  function mountAll() {
    document.querySelectorAll('[data-ghl-root]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mountAll);
  } else {
    mountAll();
  }

  // Theme editor support (Online Store 2.0 events)
  document.addEventListener('shopify:section:load', (evt) => {
    const root = evt.target.querySelector('[data-ghl-root]') || evt.target.closest('[data-ghl-root]');
    if (root) initSection(root);
  });
  document.addEventListener('shopify:section:unload', (evt) => {
    const root = evt.target.querySelector('[data-ghl-root]') || evt.target.closest('[data-ghl-root]');
    if (root) destroySection(root);
  });
})();
